const FRANCE_REGIONS = {
  'Auvergne-Rhône-Alpes': 'Auvergne-Rhône-Alpes',
  'Bourgogne-Franche-Comté': 'Bourgogne-Franche-Comté',
  Bretagne: 'Bretagne',
  'Centre-Val de Loire': 'Centre-Val de Loire',
  Corse: 'Corse',
  'Grand Est': 'Grand Est',
  'Hauts-de-France': 'Hauts-de-France',
  'Île-de-France': 'Île-de-France',
  Normandie: 'Normandie',
  'Nouvelle-Aquitaine': 'Nouvelle-Aquitaine',
  Occitanie: 'Occitanie',
  'Pays de la Loire': 'Pays de la Loire',
  "Provence-Alpes-Côte d'Azur": "Provence-Alpes-Côte d'Azur",
  France: 'France',
}

export default {
  fr: {
    ...FRANCE_REGIONS,
    title: "Zone d'action",
    'Amérique du Nord': 'Amérique du Nord',
    'Amérique du Sud': 'Amérique du Sud',
    'La Réunion': 'La Réunion',
    'Moyen-Orient': 'Moyen-Orient',
    'Nouvelle-Calédonie': 'Nouvelle-Calédonie',
    'Outre-Mer': 'Outre-Mer',
    Afrique: 'Afrique',
    Asie: 'Asie',
    Europe: 'Europe',
    Guadeloupe: 'Guadeloupe',
    Guyane: 'Guyane',
    International: 'International',
    Martinique: 'Martinique',
    Mayotte: 'Mayotte',
    Océanie: 'Océanie',
  },
  en: {
    ...FRANCE_REGIONS,
    title: 'Action regions',
    'Amérique du Nord': 'North America',
    'Amérique du Sud': 'South America',
    'La Réunion': 'Reunion',
    'Moyen-Orient': 'Middle East',
    'Nouvelle-Calédonie': 'New Calédonia',
    'Outre-Mer': 'Overseas',
    Afrique: 'Africa',
    Asie: 'Asia',
    Europe: 'Europe',
    Guadeloupe: 'Guadeloupe',
    Guyane: 'French Guiana',
    International: 'International',
    Martinique: 'Martinique',
    Mayotte: 'Mayotte',
    Océanie: 'Oceania',
  },
  'pt-br': {
    ...FRANCE_REGIONS,
    title: 'Regiones de acción',
    'Amérique du Nord': 'América do Norte',
    'Amérique du Sud': 'América do Sul',
    'La Réunion': 'Reunião',
    'Moyen-Orient': 'Oriente Medio',
    'Nouvelle-Calédonie': 'Nova Caledônia',
    'Outre-Mer': 'Ultramarinos',
    Afrique: 'África',
    Asie: 'Ásia',
    Europe: 'Europa',
    Guadeloupe: 'Guadelupe',
    Guyane: 'Guiana Francesa',
    International: 'Internacional',
    Martinique: 'Martinica',
    Mayotte: 'Mayotte',
    Océanie: 'Oceania',
  },
  es: {
    ...FRANCE_REGIONS,
    title: 'Regiões de ação',
    'Amérique du Nord': 'América del Norte',
    'Amérique du Sud': 'América del Sur',
    'La Réunion': 'La Réunion',
    'Moyen-Orient': 'Oriente Medio',
    'Nouvelle-Calédonie': 'Nueva Caledonia',
    'Outre-Mer': 'Ultramar',
    Afrique: 'África',
    Asie: 'Asia',
    Europe: 'Europa',
    Guadeloupe: 'Guadeloupe',
    Guyane: 'Guayana Francesa',
    International: 'Internacional',
    Martinique: 'Martinique',
    Mayotte: 'Mayotte',
    Océanie: 'Oceanía',
  },
  de: {
    ...FRANCE_REGIONS,
    title: 'Aktionsregionen',
    'Amérique du Nord': 'Nord-Amerika',
    'Amérique du Sud': 'Südamerika',
    'La Réunion': 'Wiedervereinigung',
    'Moyen-Orient': 'Mittlerer Osten',
    'Nouvelle-Calédonie': 'Neukaledonien',
    'Outre-Mer': 'Übersee',
    Afrique: 'Afrika',
    Asie: 'Asien',
    Europe: 'Europa',
    Guadeloupe: 'Guadeloupe',
    Guyane: 'Französisch-Guayana',
    International: 'International',
    Martinique: 'Martinique',
    Mayotte: 'Mayotte',
    Océanie: 'Ozeanien',
  },
} as const
